module.exports = __webpack_public_path__ + "static/media/concept2.6d9af71c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Twitch/Concepts/img/concept2.mp4
// module id = 247
// module chunks = 0